export default function initCommerce() {
  var toast = document.querySelector('[data-cart-toast]');
  var toastTimer = null;
  var cartNotice = document.querySelector('[data-cart-notice]');
  var cartNoticeTimer = null;
  var miniCartUpdateTimers = {};
  var miniCartUpdateRequests = {};

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (cartCount) {
      var labelTemplate = count === 1
        ? cartCount.getAttribute('data-cart-label-singular')
        : cartCount.getAttribute('data-cart-label-plural');
      var label = (labelTemplate || (count === 1 ? '%d producto' : '%d productos')).replace('%d', String(count));

      cartCount.textContent = String(count);
      cartCount.setAttribute('aria-label', label);
    });
  }

  function syncBlocksCartCount() {
    if (!window.wp || !window.wp.data || !window.wc || !window.wc.wcBlocksData || !window.wc.wcBlocksData.cartStore) {
      return;
    }

    var cartStore = window.wc.wcBlocksData.cartStore;
    var previousCount = null;

    function readCartCount() {
      var cartSelectors = window.wp.data.select(cartStore);

      if (!cartSelectors || typeof cartSelectors.getCartData !== 'function') {
        return;
      }

      if (
        typeof cartSelectors.hasFinishedResolution === 'function'
        && !cartSelectors.hasFinishedResolution('getCartData', [])
      ) {
        return;
      }

      var cartData = cartSelectors.getCartData();
      var nextCount = cartData && Number(cartData.itemsCount);

      if (!Number.isFinite(nextCount) || nextCount === previousCount) {
        return;
      }

      var hasChanged = previousCount !== null && previousCount !== nextCount;
      previousCount = nextCount;
      updateCartCount(nextCount);
      if (hasChanged && window.jQuery) window.jQuery(document.body).trigger('wc_fragment_refresh');
    }

    readCartCount();
    window.wp.data.subscribe(readCartCount, cartStore);
  }

  function showToast(message) {
    if (!toast) {
      return;
    }

    window.clearTimeout(toastTimer);
    toast.textContent = message;
    toast.classList.add('is-active');

    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-active');
    }, 2600);
  }

  function updateQuantity(control, value) {
    var input = control.querySelector('[data-quantity-input]');
    if (!input) return;

    var minimum = Number(input.getAttribute('min')) || 1;
    var maximum = Number(input.getAttribute('max')) || 999;
    var nextValue = Math.max(minimum, Math.min(maximum, value));
    input.value = String(nextValue);
  }

  function refreshMiniCartFragments(fragments, cartItemKey, focusDirection) {
    if (!window.jQuery) return;

    window.jQuery.each(fragments, function (selector, markup) {
      window.jQuery(selector).replaceWith(markup);
    });
    window.jQuery(document.body).trigger('wc_fragments_refreshed');

    var updatedItem = document.querySelector('[data-cart-item-key="' + cartItemKey + '"]');
    var focusTarget = updatedItem && updatedItem.querySelector(
      focusDirection === 'increase' ? '[data-quantity-increase]' : '[data-quantity-decrease]'
    );
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function requestMiniCartQuantity(control, focusDirection) {
    var wrapper = control.closest('[data-mini-cart-quantity]');
    var input = control.querySelector('[data-quantity-input]');
    var endpointTemplate = window.wc_add_to_cart_params && window.wc_add_to_cart_params.wc_ajax_url;
    if (!wrapper || !input || !endpointTemplate) return;

    var cartItemKey = wrapper.getAttribute('data-cart-item-key');
    var endpoint = endpointTemplate.replace('%%endpoint%%', 'crispins_update_mini_cart_quantity');
    var body = new URLSearchParams();
    body.set('cart_item_key', cartItemKey);
    body.set('quantity', input.value);
    body.set('security', wrapper.getAttribute('data-update-nonce'));

    if (miniCartUpdateRequests[cartItemKey]) miniCartUpdateRequests[cartItemKey].abort();
    var request = typeof AbortController !== 'undefined' ? new AbortController() : null;
    miniCartUpdateRequests[cartItemKey] = request;
    wrapper.classList.add('is-updating');

    window.fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: body.toString(),
      signal: request ? request.signal : undefined,
    }).then(function (response) {
      if (!response.ok) throw new Error('Mini-cart update failed');
      return response.json();
    }).then(function (response) {
      if (!response || response.error || !response.fragments) {
        throw new Error('Mini-cart response is incomplete');
      }
      refreshMiniCartFragments(response.fragments, cartItemKey, focusDirection);
      delete miniCartUpdateRequests[cartItemKey];
    }).catch(function (error) {
      if (error.name === 'AbortError') return;
      wrapper.classList.remove('is-updating');
      delete miniCartUpdateRequests[cartItemKey];
      if (window.jQuery) window.jQuery(document.body).trigger('wc_fragment_refresh');
    });
  }

  // Delegation keeps quantity controls working after catalog AJAX replacements.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
    if (!trigger) return;

    var control = trigger.closest('[data-quantity-control]');
    var input = control && control.querySelector('[data-quantity-input]');
    if (!control || !input) return;

    var direction = trigger.matches('[data-quantity-increase]') ? 1 : -1;
    updateQuantity(control, Number(input.value) + direction);

    if (control.closest('[data-mini-cart-quantity]')) {
      var cartItemKey = control.closest('[data-mini-cart-quantity]').getAttribute('data-cart-item-key');
      window.clearTimeout(miniCartUpdateTimers[cartItemKey]);
      miniCartUpdateTimers[cartItemKey] = window.setTimeout(function () {
        requestMiniCartQuantity(control, direction > 0 ? 'increase' : 'decrease');
        delete miniCartUpdateTimers[cartItemKey];
      }, 250);
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-quantity-input]')) return;

    var control = event.target.closest('[data-quantity-control]');
    if (!control) return;

    updateQuantity(control, Number(event.target.value) || 1);
    if (control.closest('[data-mini-cart-quantity]')) {
      requestMiniCartQuantity(control, 'increase');
    }
  });

  function syncAddButton(button, form) {
    var quantityInput = form.querySelector('[name="quantity"]');
    var variationInput = form.querySelector('[name="variation_id"]');
    var quantity = quantityInput ? Number(quantityInput.value) || 1 : 1;
    button.setAttribute('data-quantity', String(quantity));
    if (window.jQuery) window.jQuery(button).data('quantity', quantity);
    if (variationInput && Number(variationInput.value) > 0) {
      button.setAttribute('data-product_id', variationInput.value);
      if (window.jQuery) window.jQuery(button).data('product_id', Number(variationInput.value));
    }
  }

  // Delegation also covers cards replaced by catalog filtering/pagination.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ajax-add-to-cart] .ajax_add_to_cart');
    if (button) syncAddButton(button, button.closest('form'));
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-ajax-add-to-cart]');
    if (!form || !window.jQuery || !window.wc_add_to_cart_params) return;
    var submitter = event.submitter || document.activeElement;
    if (submitter && submitter.name === 'crispins_buy_now') return;
    var button = form.querySelector('.ajax_add_to_cart');
    if (!button) return;
    event.preventDefault();
    syncAddButton(button, form);
    button.click();
  });

  if (window.jQuery) {
    window.jQuery(document.body).on('added_to_cart', function (event, fragments, cartHash, button) {
      document.dispatchEvent(new CustomEvent('crispins:open-cart'));

      if (cartNotice) {
        window.clearTimeout(cartNoticeTimer);
        cartNotice.textContent = '';
        // Update after opening the dialog, including consecutive additions.
        window.requestAnimationFrame(function () {
          cartNotice.textContent = cartNotice.getAttribute('data-cart-notice-message');
          cartNoticeTimer = window.setTimeout(function () {
            cartNotice.textContent = '';
          }, 6000);
        });
      }
    });
  }

  syncBlocksCartCount();

  document.querySelectorAll('[data-commerce-preview]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      showToast(form.getAttribute('data-preview-message') || '');
    });
  });
}
